export class DischargeForPrint {
  _id: string;
  id: number;
  date: string;
  user: string;
  vehicle: string;
  kilometers: string;
  hoursOfUse: string;
  tank: string;
  fuel: string;
  amount: string;
  voucherId: number;
  driver: string;
}
